import { SnowplowService } from 'wanderu-service-analytics';

const category = 'Interlinking';

function linkDropdownClicked() {
    SnowplowService.fireStructuredEvent({
        category,
        action: 'link_dropdown_clicked',
    });
}

export {
    linkDropdownClicked,
};

export default {
    linkDropdownClicked,
};
